
define('known/models/productTypeModel',[
	'jquery',
	'underscore',
	'backbone',
	
	//Shims
	'backbone.relational'
], function($, _, Backbone){	
	var ProductType = Backbone.RelationalModel.extend({	
		defaults: {
			id: null,
			prodName: null,
			prodDesc: null,
			price: null,
			effDate: null,
			expDate: null,
			purchased: false,
			active: null,
			purchaseId: null
	    },
	
	    initialize: function() {
	    	
	    },
	    
	    prettyProdDesc: function() {
	    	if(this.get('prodName') == 'BASIC'){
				return "Basic";
			} else if(this.get('prodName') == 'STANDARD'){
				return "Standard";
			} else if(this.get('prodName') == 'PREMIUM'){
				return "Premium";
			} else if(this.get('prodName') == 'TRIALSTD'){
				return "Standard";
			} else if(this.get('prodName') == 'TRIALPRM'){
				return "Premium";
			} else {
				return null;
			}
	    },
	    
	    isTrial: function() {
	    	if(this.get('prodName') == 'TRIALSTD' || this.get('prodName') == 'TRIALPRM'){
				return true;
			} else {
				return false;
			}
	    }
	});
	
	return ProductType;  
});